export const NEWS_API_ENDPOINTS = {
  ADD_EVENT: "/cms/add-event",
  ADD_EVENT_FILE: "/cms/add-event-file",
  GET_EVENT_DETAILS: "/cms/get-event-details",
  UPDATE_EVENT: "/cms/update-event",
}

export interface NewsDetail {
  title: string;
  shorText: string;
  text: string;
  imageUrl: File | null;
  smallImageUrl: File | null;
  mobileImageUrl: File | null;
  mobileSmallImageUrl: File | null;
  culture: string;
}

export interface DefaultImageList {
  [key: string]: File | null;
  imageUrl: File | null;
  smallImageUrl: File | null;
  mobileImageUrl: File | null;
  mobileSmallImageUrl: File | null;
}

export interface NewsData {
  releaseDate: string;
  isVisible: boolean;
  displayOrder: number | undefined;
  activeSameImages: boolean;
  eventDetail: NewsDetail[];
  eventId?: string;
}

export const defaultImageListData: DefaultImageList[] = [
  {
    imageUrl: null,
    smallImageUrl: null,
    mobileImageUrl: null,
    mobileSmallImageUrl: null
  },
  {
    imageUrl: null,
    smallImageUrl: null,
    mobileImageUrl: null,
    mobileSmallImageUrl: null
  }
];


export const defaultNewsData: NewsData = {
  releaseDate: "",
  isVisible: false,
  displayOrder: undefined,
  activeSameImages: false,
  eventDetail: [
    {
      title: "",
      shorText: "",
      text: "",
      imageUrl: null,
      smallImageUrl: null,
      mobileImageUrl: null,
      mobileSmallImageUrl: null,
      culture: "tr-TR"
    },
    {
      title: "",
      shorText: "",
      text: "",
      imageUrl: null,
      smallImageUrl: null,
      mobileImageUrl: null,
      mobileSmallImageUrl: null,
      culture: "en-US"
    }
  ]
};
